var _path, _rect, _rect2, _path2, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFridgeUnselected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 42,
    viewBox: "0 0 94 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6928 40H38.3974V37.3978H40.9201V36.7728H38.3974V34.8068H41.1815V34.1818H37.6928V40ZM42.2504 40H42.9208V37.2387C42.9208 36.6478 43.3867 36.2159 44.0231 36.2159C44.2021 36.2159 44.3867 36.25 44.4322 36.2614V35.5796C44.3555 35.5739 44.1793 35.5682 44.0799 35.5682C43.5572 35.5682 43.1026 35.8637 42.9435 36.2955H42.8981V35.6364H42.2504V40ZM45.2269 40H45.8974V35.6364H45.2269V40ZM45.5678 34.9091C45.8292 34.9091 46.0451 34.7046 46.0451 34.4546C46.0451 34.2046 45.8292 34 45.5678 34C45.3065 34 45.0906 34.2046 45.0906 34.4546C45.0906 34.7046 45.3065 34.9091 45.5678 34.9091ZM48.7731 40.0909C49.614 40.0909 49.8981 39.5682 50.0458 39.3296H50.1254V40H50.7731V34.1818H50.1026V36.3296H50.0458C49.8981 36.1023 49.6367 35.5796 48.7844 35.5796C47.6822 35.5796 46.9208 36.4546 46.9208 37.8296C46.9208 39.2159 47.6822 40.0909 48.7731 40.0909ZM48.864 39.4887C48.0231 39.4887 47.5913 38.75 47.5913 37.8182C47.5913 36.8978 48.0117 36.1818 48.864 36.1818C49.6822 36.1818 50.114 36.8409 50.114 37.8182C50.114 38.8068 49.6708 39.4887 48.864 39.4887ZM53.8555 41.7273C54.9009 41.7273 55.7418 41.25 55.7418 40.125V35.6364H55.0941V36.3296H55.0259C54.8782 36.1023 54.6055 35.5796 53.7532 35.5796C52.6509 35.5796 51.8896 36.4546 51.8896 37.7955C51.8896 39.1591 52.685 39.9318 53.7418 39.9318C54.5941 39.9318 54.8668 39.4318 55.0146 39.1932H55.0714V40.0796C55.0714 40.8068 54.56 41.1364 53.8555 41.1364C53.0629 41.1364 52.7844 40.7188 52.6055 40.4773L52.0714 40.8523C52.3441 41.3097 52.881 41.7273 53.8555 41.7273ZM53.8327 39.3296C52.9918 39.3296 52.56 38.6932 52.56 37.7841C52.56 36.8978 52.9805 36.1818 53.8327 36.1818C54.6509 36.1818 55.0827 36.8409 55.0827 37.7841C55.0827 38.75 54.6396 39.3296 53.8327 39.3296ZM58.7987 40.0909C59.685 40.0909 60.3327 39.6478 60.5373 38.9887L59.8896 38.8068C59.7191 39.2614 59.3242 39.4887 58.7987 39.4887C58.0117 39.4887 57.4691 38.9801 57.4379 38.0455H60.6055V37.7614C60.6055 36.1364 59.6396 35.5796 58.7305 35.5796C57.5487 35.5796 56.7646 36.5114 56.7646 37.8523C56.7646 39.1932 57.5373 40.0909 58.7987 40.0909ZM57.4379 37.4659C57.4833 36.787 57.9634 36.1818 58.7305 36.1818C59.4577 36.1818 59.9237 36.7273 59.9237 37.4659H57.4379Z",
    fill: "#2A9D8F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 12.5,
    width: 17,
    height: 14,
    fill: "#2A9D8F",
    stroke: "#2A9D8F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5,
    y: 3.50003,
    width: 17,
    height: 7,
    fill: "#2A9D8F",
    stroke: "#2A9D8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 5.00003L42.5 8.00003",
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 42.5,
    y1: 14,
    x2: 42.5,
    y2: 20,
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFridgeUnselected);
export default __webpack_public_path__ + "static/media/FridgeUnselected.751c29c3.svg";
export { ForwardRef as ReactComponent };